import React from 'react'

const WorkOutDetails = () => {
  return (
    <div>WorkOutDetails</div>
  )
}

export default WorkOutDetails